var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisitorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 107,
    viewBox: "0 0 108 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.6562 99.9366L100.517 76.9243V8.69762L55.1103 30.9979H53.5578L53.6562 99.9366ZM53.6562 107C53.1584 107 52.6613 106.888 52.2008 106.662L2.02144 82.0139C0.881732 81.4569 0.15625 80.2903 0.15625 79.011V3.34705C0.15625 2.19399 0.745879 1.12222 1.71767 0.509531C2.68796 -0.100076 3.90449 -0.164712 4.93227 0.341158L53.6557 24.2713L102.381 0.339233C103.41 -0.167387 104.627 -0.102751 105.596 0.507606C106.567 1.11946 107.156 2.19209 107.156 3.3459V79.0118C107.156 80.2911 106.432 81.4577 105.293 82.0146L55.112 106.659C54.6515 106.885 54.1559 106.998 53.6566 106.998",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4073 45C65.205 45 64.0487 44.3088 63.4865 43.1205C62.6981 41.4592 63.3704 39.4586 64.9809 38.648L87.4856 27.3391C89.0961 26.5291 91.0402 27.2202 91.827 28.8808C92.6132 30.5414 91.9431 32.5441 90.3312 33.3533L67.8283 44.6631C67.3698 44.8917 66.8829 45 66.4069 45",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4073 62.9998C65.205 62.9998 64.0487 62.3086 63.4865 61.1203C62.6981 59.4595 63.3704 57.458 64.9809 56.6474L87.4856 45.3392C89.0961 44.5292 91.0402 45.2196 91.827 46.8803C92.6132 48.5418 91.9431 50.5455 90.3312 51.3532L67.8283 62.6608C67.3698 62.8909 66.8829 63 66.4069 63",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4073 80.9999C65.205 80.9999 64.0487 80.3087 63.4865 79.1202C62.6981 77.4594 63.3704 75.4577 64.9809 74.647L87.4856 63.34C89.0961 62.5292 91.0402 63.2182 91.827 64.879C92.6132 66.5421 91.9431 68.5444 90.3312 69.3537L67.8283 80.6623C67.3698 80.8932 66.8829 81 66.4069 81",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitorIcon);
export default __webpack_public_path__ + "static/media/VisitorIcon.f746e613b8cf65971aeedddf7efeeb63.svg";
export { ForwardRef as ReactComponent };